export async function loadAsyncJsLib(url, { crossOrigin = 'anonymous' } = {}) {
  return new Promise((resolve, reject) => {
    const newScript = document.createElement('script');
    newScript.onerror = (e) => reject(new Error(`Failed to load ${e.target.src}`));
    newScript.onload = () => resolve();

    document.head.appendChild(newScript);
    newScript.async = true;
    newScript.defer = true;
    // O endpoint do GIS (accounts.google.com/gsi/client) não envia
    // Access-Control-Allow-Origin; marcar o script como CORS faz o browser
    // bloquear o load. Por isso o crossOrigin é opcional (null desliga).
    if (crossOrigin !== null) {
      newScript.crossOrigin = crossOrigin;
    }
    newScript.src = url;
  });
}

export function delayInSeconds(seconds = 1) {
  return new Promise(resolve => setTimeout(resolve, seconds * 1000));
}

export function deferredPromise() {
  let _resolve = (value) => {value};
  let _reject = (reason=null) => {reason};

  const promise = new Promise((resolve, reject) => {
    _resolve = resolve;
    _reject = reject;
  });

  return {
    promise,
    resolve: _resolve,
    reject: _reject,
  };
}
